import { CONTENT_TYPES } from 'components/ContentReporting/content-types';

export const ACCEPTED_URI_TYPES_ALL = Object.values(CONTENT_TYPES);
